import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { OEContext } from '@aytm/app/stats/page/comments'
import style from '@aytm/app/stats/page/comments/comments/styles/Response.module.scss'
import useResponseStatus from '@aytm/app/stats/page/comments/hooks/useResponseStatus'

const Approve = memo(({ responseId, onChangeResponseStatus }) => {
  const onApprove = () => {
    if (onChangeResponseStatus) {
      onChangeResponseStatus(responseId, 'approve')
    }
  }

  const { status, isQAMode, qaAction, qaProcessedResponseId } = useResponseStatus(
    OEContext,
    responseId,
    'approve',
    event => {
      if ((49 == event.keyCode || 97 == event.keyCode || 35 == event.keyCode) && event.shiftKey) {
        onApprove()
      }
    }
  )

  switch (true) {
    case 'loading' == status || (isQAMode && 'approve' == qaAction && qaProcessedResponseId == responseId):
      return <i className="icon-aytmfd-refresh-v2 aytmfd-spin" />
    case 'object' == typeof status && 'error' == status.type:
      return <>Error</>
    default: {
      return (
        <div className={style['response-header-approve']}>
          <i className="icon-aytmfd-thumbsUp" onClick={onApprove} />
        </div>
      )
    }
  }
})

Approve.propTypes = {
  response: PropTypes.object,
  responseId: PropTypes.number,
  onChangeResponseStatus: PropTypes.func
}

Approve.displayName = 'Approve'

export default Approve
